import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";

library.add(fas);
library.add(fab);
library.add(far);

const Icon = ({
  size,
  name,
  iconPrefix,
  onclick,
  color,
  title,
  className,
  style,
  containerStyle,
  id,
}) => {
  return (
    <div
      style={
        onclick != null ? { cursor: "pointer" } : { pointerEvents: "none" }
      }
      className={containerStyle ?? className}
    >
      <FontAwesomeIcon
        id={id}
        className={className}
        color={color ?? "rgb(12, 87, 76)"}
        onClick={onclick}
        style={{ fontSize: size ?? 20, ...style }}
        icon={[iconPrefix, name]}
        title={title}
      ></FontAwesomeIcon>
    </div>
  );
};

export default Icon;
